<template>
  <div>

    <b-card title="Introduction">
      <b-card-body>
        <p> As you saw in <b-link>here</b-link>, the total number of values representable is directly correleated to the number 
            of bits used. In the case of signed integers, however, we need to allow half of the values be negative an the other
            half be non-negative. This fact means the that the absolute value of the highest and lowest values is half that of 
            the highest value for unsigned integers. For example, for an 8-bit signed integer the lowest negative value is -128,
            while the highest positive value is 127. The distance from zero is one less for the positive integers than for the 
            negative integers be cause we must also include value 0 in the set of non-negative integers.
        </p>
        <p> In general, for any number of bits, the lowest signed integer value representable is -2<sup>n - 1</sup>. We must
            subtract one from the exponent because we have cut the number of values in half (2<sup>n</sup>/2 = 2<sup>n-1</sup>). The highest 
            signed integer value representable is 2<sup>n - 1</sup> - 1 (because the first number is zero, not 1). In general we can say the the 
            range of representable signed integer values for n-bits is -2<sup>n - 1</sup> to 2<sup>n - 1</sup> - 1.
        </p>
      </b-card-body>
    </b-card><p/>
    <b-card title="Try it yourself">
      <b-card-body>
        <table>
          <tr>
            <td class="ranges-range">
              # of bits =  
            </td>
            <td class="ranges-range">
              <b-form-input type="number" v-model="bits" class="ranges-n" :min="1" :max="70"/>
            </td>
            <td class="ranges-range">
              The range of representable numbers for an {{bits}}-bit signed integer is -{{((2 ** (bits - 1))).toLocaleString()}} to {{((2 ** (bits-1)) - 1).toLocaleString()}} 
            </td>
          </tr>
        </table>
      </b-card-body>
    </b-card><p/>

    </div>
</template>

<script>

export default {
  data () {
    return {
      bits: 1,
      bits1: [
        {value: 0, bits: '0'},
        {value: 1, bits: '1'}
      ],
      bits2: [
        {value: 0, bits: '00'},
        {value: 1, bits: '01'},
        {value: 2, bits: '10'},
        {value: 3, bits: '11'}
      ],
      bits3: [
        {value: 0, bits: '000'},
        {value: 1, bits: '001'},
        {value: 2, bits: '010'},
        {value: 3, bits: '011'},
        {value: 4, bits: '100'},
        {value: 5, bits: '101'},
        {value: 6, bits: '110'},
        {value: 7, bits: '111'}
      ],
      bits4: [
        {value: 0, bits: '0000'},
        {value: 1, bits: '0001'},
        {value: 2, bits: '0010'},
        {value: 3, bits: '0011'},
        {value: 4, bits: '0100'},
        {value: 5, bits: '0101'},
        {value: 6, bits: '0110'},
        {value: 7, bits: '0111'},
        {value: 8, bits: '1000'},
        {value: 9, bits: '1001'},
        {value: 10, bits: '1010'},
        {value: 11, bits: '1011'},
        {value: 12, bits: '1100'},
        {value: 13, bits: '1101'},
        {value: 14, bits: '1110'},
        {value: 15, bits: '1111'}
      ]
    }
  }
}
</script>

<style scoped>
.ranges-bits {
  max-width: 75px;
  vertical-align: top;
}

.ranges-range {
  vertical-align: middle;
  padding-right: 5px;
  font-size: large;
}

.ranges-n {
  max-width: 70px;
}

tr, td {
  vertical-align: top;
  padding-right: 3.5em;
}
</style>


// WEBPACK FOOTER //
// src/components/signed-ranges.vue